<div class="row">
  <card [name]="'Create action'" class="col col-120 col-lg-80 col-xl-80">
    <div card content class="row">
      <custom-data-form class="col col-120 "
                   [data]="item"
                   (submited)="onSubmit($event)">
        <button class="btn btn-success float-right" type="submit">Create</button>
        <!--        <a class="btn btn-outline-info float-right ml-2" type="button" (click)="back($event)">Back</a>-->
      </custom-data-form>
    </div>
  </card>
  <card name="Library" class="col col-120 col-lg-40 col-xl-40">
    <div card content class="vh-70 overflow-scroll">
      <library-list [store]="item?.store"></library-list>
    </div>
  </card>
</div>
